import { TradingConfig } from './models/trading/types';

export let tradingConfig: TradingConfig = {
  exDestination: 'DEMO',
  subDestination: 'NYSE', // NYSE, SMART etc. (taken care by SOR?)
};
export function setTradingConfig(updateObject: object) {
  Object.assign(tradingConfig, updateObject);
}
